export default "__VITE_ASSET__DGcyTzSf__"